// hooks/useFocusHandler.js
import { useEffect } from 'react';

const useFocusHandler = () => {
  useEffect(() => {
    const handleFocusIn = (event) => {
      const target = event.target;

      if (target.tagName === "INPUT" || target.tagName === "TEXTAREA") {
        console.warn("Input or textarea focused:", target.id);

        // Scroll the focused element into view
        target.scrollIntoView({ behavior: 'smooth', block: 'center' });

        // Send a postMessage to the parent app
        window.parent.postMessage(
          { type: "FOCUS_IN", target: target.id },
          "*" // Use '*' to allow cross-origin communication
        );
      }
    };

    document.addEventListener("focusin", handleFocusIn);

    window.addEventListener('message', (event) => {
      if (event.data.type === 'SCROLL_INTO_VIEW') {
        const targetElement = document.getElementById(event.data.target);
        if (targetElement) {
          console.log('Scrolling element into view:', targetElement.id);

          // Scroll the focused element into view with an offset for the keyboard
          targetElement.scrollIntoView({
            behavior: 'smooth',
            block: 'center',
          });
        }
      }
    });

    // Cleanup event listeners on unmount
    return () => {
      document.removeEventListener("focusin", handleFocusIn);
      window.removeEventListener('message', (event) => {});
    };
  }, []);
};

export default useFocusHandler;